import { Box, Paper, Tab, Tabs } from "@mui/material";
import React from "react";

import { useECSContext } from "./ecsContext";

import { ECSTabs } from "./ECSTabs";
import {
  getHashdata,
  setHash,
} from "../../../../../../components/Tabs/Utils/hashFunctions";
import TabPanelFormat from "../../../../../../components/widgets/TabPanelFormat";

export default function ECSMain() {
  const { project, currentTab, setCurrentTab } = useECSContext();

  const tabs = ECSTabs;

  const navLabel = "ecs-tab";

  const fullHash = window.location.hash;
  React.useEffect(() => {
    const hashValue = getHashdata(fullHash, navLabel);
    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue)
    );

    // if hash value for tabs is present, set it as currentTab
    if (tabIndex !== -1) {
      setCurrentTab(tabIndex);
    }
    // if its not present, but there is some existing hash value, add this to the hash value
    else if (fullHash)
      window.location.hash = fullHash + "&" + navLabel + "=" + tabs[0].label;
    // if not either, start a new hash
    else window.location.hash = navLabel + "=" + tabs[0].label;
  }, []);

  const handleChange = (event, newValue) => {
    // console.log("CHNGE");
    setCurrentTab(newValue);

    setHash(fullHash, navLabel, tabs[newValue].label);
  };

  return (
    <Paper
      sx={{
        width: "100%",
        display: "flex",
        backgroundColor: "white",
      }}
    >
      <Box {...{ width: "100%", overflow: "auto" }}>
        <Tabs
          value={currentTab}
          onChange={handleChange}
          orientation={"horizontal"}
        >
          {tabs.map((tab, i) => {
            return <Tab label={tab.label} value={i} />;
          })}
        </Tabs>

        <TabPanelFormat {...tabs[currentTab]?.panelProps}>
          {tabs[currentTab]?.panel}
        </TabPanelFormat>
      </Box>
    </Paper>
  );
}
